import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
class PartiesUnitDetails extends React.Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      unit: this.props.unit,
      subAssetName: this.props.subAssetName,
      tower: this.props.tower,
      landlord: this.props.landlordDetails,
    };
  }
  getTotalGrossleasableArea() {
    let totalGrossleasableArea = 0;
    for (let i = 0; i < this.state.unit.length; i++) {
      totalGrossleasableArea += this.state.unit[i].grossLeasableArea;
    }
    return totalGrossleasableArea;
  }

  render() {
    return (
      <div className="tabHolder outsideAccordian mb-4 detailswithTwoLabels">
        <div className="row tabForm">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Landlord Asset Name <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.props.assetValue}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Landlord Sub Asset Name <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.props.subAssetValue}
                      {this.props.subAssetNameValue}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Tower Name <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.props.towerValue}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.landlord.map(function (name, index) {
            return (
              <div className="container" key={index}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Landlord Group <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {name.companyGroupValue}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Landlord Company Name{" "}
                          <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {name.companyNameValue}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          GST Number <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {name.gstNumber}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Landlord GST State
                          <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {name.gstStateValue}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Vendor Code
                          <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {name.vendorCode}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-4 col-form-label">
                          Notes
                          <span className="astrik">*</span>
                        </label>
                        <label className="col-sm-7 col-form-label">
                          {this.props.landlordNotes}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="inputContainer col-lg-12 col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">
                          Unit Details
                        </label>
                        <div className="col-sm-10 slabWidthDesktop">
                          <div
                            className="tableContainer"
                            style={{ padding: "15px" }}
                          >
                            <table className="table tableSimple tableSimpleWithNoFlex">
                              <thead>
                                <tr>
                                  <th className="darkBGBlue">#</th>
                                  <th className="darkBGBlue" scope="col">Floor </th>
                                  <th className="darkBGBlue" scope="col">Unit No</th>
                                  <th className="darkBGBlue" scope="col">Unit Type</th>
                                  <th className="darkBGBlue" scope="col">Unit Status</th>
                                  <th className="darkBGBlue" scope="col">Ownership Percent %</th>
                                  <th className="darkBGBlue" scope="col">Carpet Area (sq.ft)</th>
                                  <th className="darkBGBlue" scope="col">Usable Area (sq.ft)</th>
                                  <th className="darkBGBlue" scope="col">
                                    Gross Leasable Area (sq.ft)
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.unit !== undefined &&
                                  this.state.unit.length > 0 &&
                                  this.state.unit
                                    .filter(
                                      (landlord) =>
                                        landlord.landlord ===
                                        this.state.landlord[index].companyName
                                    )
                                    .map((name, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{name.floor}</td>
                                        <td>{name.unitNo}</td>
                                        <td>{name.unitType}</td>
                                        <td>{name.unitStatus}</td>
                                        <td>{name.ownershipPercent}</td>
                                        <td>{name.carpetArea}</td>
                                        <td>{name.usableArea}</td>
                                        <td>{name.grossLeasableArea}</td>
                                      </tr>
                                    ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }, this)}
        </div>
        <div className="row pt-3 pb-3">
          <div className="col-lg-12 text-center">
            <div className="inputContainer col-lg-12 col-md-12">
              <label
                style={{
                  fontWeight: "600",
                  fontSize: "15px",
                  marginRight: "40px",
                }}
              >
                Total Gross Leasable Area (sq.ft):
              </label>
              <label style={{ fontWeight: "600", fontSize: "15px" }}>
                {this.getTotalGrossleasableArea()}
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(PartiesUnitDetails);
